import React, { useEffect, useState } from "react";
import SapakimHead from "./SapakimHead";
import '../Styles/Sapakim/SHome.css';
import { useNavigate, useParams } from "react-router-dom";
import { collection, query, where, getCountFromServer, doc, getDoc, getDocs } from "firebase/firestore";
import { db } from "../Components/Firebase";
import Loading from "../Components/Loading";

function SHome() {
  const nav = useNavigate();
  const { UID } = useParams();

  const [ordersCount, setOrdersCount] = useState(0);
  const [customersCount, setCustomersCount] = useState(0);
  const [quotationsCount, setQuotationsCount] = useState(0);
  const [catalogCount, setCatalogCount] = useState(0);
  const [docsCount, setDocsCount] = useState(0); // Docs count
  const [userData, setUserData] = useState({ Name: "", CompanyNumber: "" });
  const [ads, setAds] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    document.title = 'מערכת ספקים (מילאז)';
    
    const fetchData = async () => {
      try {
        // Orders count
        const ordersQuery = query(collection(db, "Orders"), where("SapakId", "==", UID));
        const ordersSnapshot = await getCountFromServer(ordersQuery);
        setOrdersCount(ordersSnapshot.data().count);

        // Customers count
        const customersQuery = query(collection(db, "Customers"), where("SapakId", "==", UID));
        const customersSnapshot = await getCountFromServer(customersQuery);
        setCustomersCount(customersSnapshot.data().count);

        // Quotations count
        const quotationsQuery = query(collection(db, "Quotations"), where("SapakId", "==", UID));
        const quotationsSnapshot = await getCountFromServer(quotationsQuery);
        setQuotationsCount(quotationsSnapshot.data().count);

        // Catalog count
        const catalogSnapshot = await getCountFromServer(collection(db, "Catalog"));
        setCatalogCount(catalogSnapshot.data().count);

        // Docs count
        const docsQuery = query(collection(db, "Docs"), where("SUID", "==", UID));
        const docsSnapshot = await getCountFromServer(docsQuery);
        setDocsCount(docsSnapshot.data().count);

        // User data
        const userRef = doc(db, "Users", UID);
        const userSnap = await getDoc(userRef);
        if (userSnap.exists()) {
          const data = userSnap.data();
          setUserData({
            Name: data.Name || "",
            CompanyNumber: data.CompanyNumber || ""
          });
        }

        // Ads
        const adsSnapshot = await getDocs(collection(db, "Ads"));
        const adsList = adsSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setAds(adsList);

      } catch (error) {
        console.error("שגיאה בקבלת נתונים:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [UID]);

  return (
    <React.Fragment>
      <SapakimHead />

      {loading ? (
        <Loading />
      ) : (
        <>
          {/* User Info */}
          <div className="SInfo" dir="rtl">
            <h1>שם: {userData.Name}</h1>
            |
            <h1>ח.פ: {userData.CompanyNumber}</h1>
          </div>

          {/* Functions */}
          <div className="functions" dir="rtl">
            <div className="FBox">
              <h1>הזמנות</h1>
              <h2>{ordersCount}</h2>
              <button onClick={() => { nav(`/SapakimHome/${UID}/SViewAllOrders`) }}>הצג הכל</button>
            </div>
            <div className="FBox">
              <h1>בקשת הצעת מחיר</h1>
              <h2>{quotationsCount}</h2>
              <button onClick={() => { nav(`/SapakimHome/${UID}/SQuotations`) }}>הצג הכל</button>
            </div>
            <div className="FBox">
              <h1>לקוחות</h1>
              <h2>{customersCount}</h2>
              <button onClick={() => { nav(`/SapakimHome/${UID}/SViewCustomers`) }}>הצג הכל</button>
            </div>
            <div className="FBox">
              <h1>מסמכים</h1>
              <h2>{docsCount}</h2> {/* Show docs count */}
              <button onClick={() => {nav(`/SapakimHome/${UID}/SDocs`)}}>הצג הכל</button>
            </div>
            <div className="FBox">
              <h1>קטלוג</h1>
              <h2>{catalogCount}</h2>
              <button onClick={() => { nav(`/SapakimHome/${UID}/SCatalog`) }}>הצג הכל</button>
            </div>
          </div>

          {/* Ads Section */}
          <h2 className="ads-title" dir="rtl">מודעות</h2>
          <div className="ads-grid" dir="rtl">
            {ads.length === 0 ? (
              <p>אין מודעות להצגה</p>
            ) : (
              ads.map(ad => (
                <div className="ad-card" key={ad.id}>
                  <img src={ad.imageUrl} alt={ad.name} />
                  <h3>{ad.name}</h3>
                  <p>{ad.info}</p>
                </div>
              ))
            )}
          </div>
        </>
      )}
    </React.Fragment>
  );
}

export default SHome;
